import LeanPay from './LeanPay';

export default LeanPay;
